import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isPDFDownloading: false,
  isDownload: false,
  isReceiptPdfLoading: false,
  receiptPdfData: {},
  receiptPDF: {},
  membershipAgreementPDF: {},
  error: null,
};

const loadMembershipAgreementPDFRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isPDFDownloading: true,
    error: null,
  };
};

const loadMembershipAgreementPDFSuccess = (state = INITIAL_STATE, { pdfData }) => {
  // Always expecting both PDFs since we fetch them together
  return {
    ...state,
    isDownload: true,
    isPDFDownloading: false,
    receiptPDF: pdfData.receiptPDF,
    membershipAgreementPDF: pdfData.membershipAgreementPDF,
  };
};

const loadMembershipAgreementPDFFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isPDFDownloading: false,
    isDownload: false,
    error,
  };
};

const loadMembershipReceiptPDFRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isReceiptPdfLoading: true,
    error: null,
  };
};

const loadMembershipReceiptPDFSuccess = (state = INITIAL_STATE, { receiptPdfData }) => {
  return {
    ...state,
    receiptPdfData,
    isReceiptPdfLoading: false,
  };
};

const loadMembershipReceiptPDFFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isReceiptPdfLoading: false,
    error,
  };
};

export const HANDLERS = {
  [Types.LOAD_MEMBERSHIP_AGREEMENT_PDF_REQUEST]: loadMembershipAgreementPDFRequest,
  [Types.LOAD_MEMBERSHIP_AGREEMENT_PDF_SUCCESS]: loadMembershipAgreementPDFSuccess,
  [Types.LOAD_MEMBERSHIP_AGREEMENT_PDF_FAILURE]: loadMembershipAgreementPDFFailure,
  [Types.LOAD_MEMBERSHIP_RECEIPT_PDF_REQUEST]: loadMembershipReceiptPDFRequest,
  [Types.LOAD_MEMBERSHIP_RECEIPT_PDF_SUCCESS]: loadMembershipReceiptPDFSuccess,
  [Types.LOAD_MEMBERSHIP_RECEIPT_PDF_FAILURE]: loadMembershipReceiptPDFFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
